import cn from "classnames"
import { RenderBardWithComponents } from "components/Wysiwyg"
import Link from "next/link"
import { DynamicHeadline } from "../../DynamicHeadline"
import Image from "../../Image"
import styles from "./TeaserLinksItem.module.scss"

export const TeaserLink = ({ url, children, className, openNewTab }) => {
  return url ? (
    <Link href={url}>
      <a className={className} target={openNewTab ? "_blank" : "_self"}>
        {children}
      </a>
    </Link>
  ) : (
    <div className={className}>{children}</div>
  )
}

const TeaserLinksItem = ({ teaser, className }) => {
  const {
    link_link: link,
    link_image: image,
    link_text: text,
    link_anchor: anchor,
    dynamic_headline: headline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
    new_tab: newTab,
  } = teaser

  const teaserLinkWrapperCN = cn(styles.teaserLinkWrapper, className, {
    [styles.withImage]: image,
    [styles.withoutImage]: !image,
  })

  const bgCN = cn(styles.bg, {
    "-ml-8 -mt-24 sm:-mt-56 lg:-mt-24 xl:-mt-56": image,
    "-ml-8": !image,
  })

  const linkWithAnchor = anchor ? `${link}#${anchor}` : link

  return (
    <TeaserLink
      className={teaserLinkWrapperCN}
      url={linkWithAnchor}
      openNewTab={newTab}
    >
      {image && (
        <div className={styles.imageWrapper}>
          <Image
            src={image.permalink}
            alt={image.alt}
            className={styles.image}
            quality={100}
            style={{ objectPosition: image.focus_css }}
            sizes="(max-width: 1024px) 1920px, (max-width: 1280px) 828px, (max-width: 1720px) 768px, 1080px"
            fill
          />
        </div>
      )}
      <div className={styles.inner}>
        <div className={bgCN} aria-hidden />
        <div className={styles.content}>
          {headline && (
            <DynamicHeadline
              className={styles.headline}
              headlineType={headlineType.value}
              headlineAppearance={headlineAppearance.value}
            >
              {headline}
            </DynamicHeadline>
          )}
          {text && (
            <div className={styles.text}>
              <RenderBardWithComponents content={text} prefix="link_text_" />
            </div>
          )}
        </div>
      </div>
    </TeaserLink>
  )
}

export default TeaserLinksItem
